module.exports = __webpack_public_path__ + "img/6.753d0b91.png";